import "../style.scss";

import { TextareaAutosize } from "@mui/material";
import TextField from "@mui/material/TextField";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import type { FocusEventHandler } from "react";
import { forwardRef } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface ITextAreaFormComponent {
    label: string;
    placeholder?: string;
    control: any;
    controlName: string;
    /** Adjust the height of the area by displaying number of rows */
    minRows?: number;
    maxRows?: number;
    style?: any;
    onFocus?: FocusEventHandler<HTMLTextAreaElement> | undefined;
    required?: boolean;
    error?: any;
    disabled?: boolean;
}

/**
 * @param minRows minimal number of rows
 * @param maxRows maximum number of rows
 * @param style adjust style for conditionnal style render
 */
const TextAreaFormComponent = forwardRef<any, ITextAreaFormComponent>(function TextAreaFormComponent(
    props: ITextAreaFormComponent,
    ref,
) {
    const {
        label,
        placeholder,
        control,
        controlName,
        minRows,
        maxRows,
        style,
        onFocus,
        required,
        error,
        disabled = false,
    } = props;
    const [t] = useTranslation();

    return (
        <div className="form-component">
            <Controller
                name={controlName}
                control={control}
                render={({ field }) => {
                    return (
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label className="form-component-label" htmlFor={controlName}>
                                {label}
                                {required && label && "*"}
                            </label>
                            <TextareaAutosize
                                {...field}
                                className="form-text-area"
                                minRows={minRows}
                                maxRows={maxRows}
                                name={controlName}
                                placeholder={placeholder}
                                style={style}
                                onFocus={onFocus}
                                required={required}
                                ref={ref}
                                disabled={disabled}
                            />
                        </div>
                    );
                }}
            />
        </div>
    );
});

export default TextAreaFormComponent;
